import React, { useEffect } from 'react'
import { Parallax } from 'react-parallax'

const Fourthpara = () => {
  useEffect(() => {
    const section = document.querySelector('#projects')
    const lists = document.querySelectorAll('.projects-li')
    const item = document.querySelectorAll('.project-item')
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          lists.forEach(i => {
            i.classList.add('animated-projects')
          })
          item.forEach(i => {
            i.classList.add('animated-item')
          })
        }
      })
    })

    observer.observe(section)
  }, [])

  useEffect(() => {
    const section = document.querySelector('.works')
    const item = document.querySelectorAll('.project-item')
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          item.forEach(i => {
            i.classList.add('animated-item')
          })
        }
      })
    })

    observer.observe(section)
  }, [])

  return (
    <Parallax
      style={{ background: 'linear-gradient(black 38%, white 20%)' }}
      className='paralax'
      bgImage={'white'}
      strength={400}
    >
      <section id='projects' className='secondpara sp-fp'>
        <div className='projects-li title title-fp'>
          <p style={{ color: 'red', fontFamily: 'Righteous' }}>RECENT WORKS</p>
          <br />
          <div style={{ color: 'white', fontFamily: 'Righteous' }}>
            I love what I do, check out some of my latest works
          </div>
          <hr />
        </div>

        <div className=' projects-li works'>
          <div className='project-item'>
            <div className='project-name'>
              <p style={{ color: 'white' }}>ALASSO</p>
              <div style={{ color: 'white' }}>
                Alasso is an online educational community that was founded as an
                online platform that helps young students to get answers for
                reference and study materials for the preparation of exams,
                worksheets, certification courses especially in the engineering
                stream.{<br />} Features like ongoing coding contest, best
                videos on internet to enhance skills, roadmaps to learn new
                technologies, answer helpers are introduced.
              </div>
            </div>
            <div className='project-image'>
              <img className='pi' src='/projects/alasso.png' alt='' />
              <a
                className='open'
                target={'_blank'}
                rel='noreferrer'
                href='https://alasso.tech'
              >
                <i class='fa fa-link' aria-hidden='true'></i>
              </a>
            </div>
          </div>
          <div className='project-item'>
            <div className='project-image'>
              <img className='pi' src='/projects/uniride.png' alt='' />
              {/* <a className='open' target={'_blank'} href='https://alasso.tech'>
                <i class='fa fa-link' aria-hidden='true'></i>
              </a> */}
            </div>
            <div className='project-name'>
              <p style={{ color: 'white' }}>UNI-RIDE</p>
              <div style={{ color: 'white' }}>
                UNI-RIDE is a car/bike pooling system which provides a viable
                solution to this problem by reducing the number of cars on the
                road, easing traffic congestion, and promoting a more
                sustainable form of transportation. By connecting students with
                other students or faculty who are going to college at the same
                time, the system can provide a convenient and cost-effective
                means of transportation. Therefore, it's imperative to address
                this issue and provide a reliable and safe commuting solution
                for students living outside the campus.
              </div>
            </div>
          </div>
          <div className='project-item'>
            <div className='project-name'>
              <p style={{ color: 'white' }}>CARE CONNECT</p>
              <div style={{ color: 'white' }}>
                "Care Connect" is a fast and reliable web application that
                assists users in finding healthcare resources, including
                hospitals, blood banks, medicines, oxygen cylinders, and lab
                tests. Built using the latest web development technologies, it
                has an intuitive interface and powerful search functionality,
                making it easy to use on any device. The backend system sends
                queries to a dedicated team to provide accurate and up-to-date
                information. This project showcases the developer's skills in
                creating user-friendly solutions to real-world problems, and
                it's an excellent addition to any portfolio website.
              </div>
            </div>
            <div className='project-image'>
              <img className='pi' src='/projects/care.png' alt='' />
              <a
                className='open'
                target={'_blank'}
                href='https://careconnnect.netlify.app'
              >
                <i class='fa fa-link' aria-hidden='true'></i>
              </a>
            </div>
          </div>
          <div className='project-item'>
            <div className='project-image'>
              <img className='pi' src='/projects/dice.png' alt='' />
              {/* <a className='open' target={'_blank'} href='https://alasso.tech'>
                <i class='fa fa-link' aria-hidden='true'></i>
              </a> */}
            </div>
            <div className='project-name'>
              <p style={{ color: 'white' }}>ROLLING-DICE</p>
              <div style={{ color: 'white' }}>
                Rolling-Dice is an fun intresting game, with a lot of ow!
                moments, where users can play that game in their free time.
                Users have to roll a virtual dice and the score keeps up adding
                and hold the score and pass the chance to the opponent player.
                When 1 comes, all the score becomes zero and chance to roll is
                transffered, who so ever reaches the score of 100 first wins the
                game.
              </div>
            </div>
          </div>
        </div>
      </section>
    </Parallax>
  )
}

export default Fourthpara
